// Extends from
import PostsSerializer from './base';

export default class Page extends PostsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      assessmentIds: [],
      goalSubjectIds: [],
      tagCategoryIds: [],
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
